module.exports = __webpack_public_path__ + "components/flag/static/square/gh-450f93c75a71427f6046ddc5e9a5b573.svg";